<template>
  <confirmation-slip :manifests="manifests" />
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmationSlip from '../../../components/_ConfirmationSlip'

export default {
  name: 'DriverManifestConfirmationSlip',
  components: {
    ConfirmationSlip
  },
  mixins: [],
  props: {},
  data() {
    return {
      systemTime: null,
      manifests: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
    const params = this.$route.query
    this.fetchManifests({ params: params }).then((content) => {
      this.manifests = content.manifests
    })
  },
  methods: {
    ...mapActions('DriverManifestConfirmationSlip', {
      fetchManifests: 'index',
    }),
  }
}
</script>


